<template>
    <v-container fluid fill-height class="py-0">
        <router-view name="notifications"></router-view>
        <transition name="fadeonly" mode="out-in">
            <router-view></router-view>
        </transition>
    </v-container>
</template>

<script>
export default {}
</script>
